// ============================================================================
// ITALIAN TRANSLATIONS - BIBLE TREASURES
// ============================================================================
// Tesori spirituali estratti dalla Parola

export const bibleTreasures = [
  {
    type: "perle_sagesse",
    content: "La sapienza divina non è teoria astratta, ma vita concreta che si manifesta nelle nostre scelte quotidiane",
    reference: "Proverbi 3:13-18",
    category: "sapienza",
    strongNumbers: {
      "sapienza": "H2451", // חָכְמָה (chokmah) = sapienza pratica
      "intelligenza": "H8394" // תְּבוּנָה (tebunah) = discernimento
    },
    reflection: "Come posso applicare la sapienza divina nelle mie decisioni oggi?"
  },
  {
    type: "tresor_divine",
    content: "L'amore di Dio non è condizionato ai nostri meriti, ma un dono eterno che fluisce dalla Sua stessa natura",
    reference: "Romani 8:38-39",
    category: "amore",
    strongNumbers: {
      "amore": "G26", // ἀγάπη (agape) = amore incondizionato
      "separare": "G5563" // χωρίζω (chorizo) = separare
    },
    reflection: "Nulla può separarci dall'amore di Dio rivelato in Cristo"
  },
  {
    type: "lumiere_vie",
    content: "Gesù è la luce che illumina non solo il nostro cammino, ma anche il nostro essere interiore",
    reference: "Giovanni 8:12",
    category: "identità",
    strongNumbers: {
      "luce": "G5457", // φῶς (phos) = luce
      "vita": "G2222" // ζωή (zoe) = vita abbondante
    },
    reflection: "Come lascio che la luce di Cristo illumini le mie aree di oscurità?"
  },
  {
    type: "force_divine",
    content: "La nostra forza non proviene da noi stessi, ma da Colui che abita in noi",
    reference: "Efesini 3:16-17",
    category: "potenza",
    strongNumbers: {
      "fortificati": "G2901", // κραταιόω (krataioo) = fortificare
      "potenza": "G1411" // δύναμις (dynamis) = potenza divina
    },
    reflection: "Nei miei momenti di debolezza, confido nella forza di Dio?"
  },
  {
    type: "paix_profonde",
    content: "La pace di Dio non dipende dalle circostanze esterne, ma dalla Sua presenza costante nei nostri cuori",
    reference: "Filippesi 4:6-7",
    category: "serenità",
    strongNumbers: {
      "pace": "G1515", // εἰρήνη (eirene) = pace completa
      "custodirà": "G5432" // φρουρέω (phroureo) = custodire come fortezza
    },
    reflection: "Come coltivo la pace di Dio che supera ogni intelligenza?"
  },
  {
    type: "esperance_vivante",
    content: "La nostra speranza non è un desiderio incerto, ma un'ancora solida fondata sulle promesse fedeli di Dio",
    reference: "Ebrei 6:19",
    category: "speranza",
    strongNumbers: {
      "speranza": "G1680", // ἐλπίς (elpis) = speranza fiduciosa
      "ancora": "G45" // ἄγκυρα (ankyra) = ancora dell'anima
    },
    reflection: "In quali promesse di Dio ancoro la mia speranza oggi?"
  },
  {
    type: "transformation",
    content: "La trasformazione spirituale è un processo continuo in cui diventiamo ogni giorno più simili all'immagine di Cristo",
    reference: "2 Corinzi 3:18",
    category: "crescita",
    strongNumbers: {
      "trasformati": "G3339", // μεταμορφόω (metamorphoo) = trasformare completamente
      "gloria": "G1391" // δόξα (doxa) = gloria divina
    },
    reflection: "Quali aree della mia vita hanno bisogno di trasformazione oggi?"
  }
];

export default bibleTreasures;
